import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { Asset, AssetResponse, AssetType } from "../../types";

// Define the query parameters interface
interface GetAssetsParams {
  type: AssetType;
  project_id?: string;
}

export const assetApiV2 = createApi({
  reducerPath: "assetApiV2",
  baseQuery: fetchBaseQuery({
    baseUrl: "/is/asset",
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as { auth: { token: string } }).auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Asset"],
  endpoints: (build) => ({
    getAssets: build.query<AssetResponse<AssetType>, GetAssetsParams>({
      query: ({ type, project_id }) => {
        const params = new URLSearchParams();
        if (project_id) {
          params.append('project_id', project_id);
        }
        return {
          url: `/${type}?${params.toString()}`,
          method: 'GET'
        };
      },
      providesTags: ["Asset"],
    }),
  }),
});

export const {
  useGetAssetsQuery,
} = assetApiV2;